/**
 * hover 時に BarElement の inflatAmount を変更するプラグイン
 *
 * option
 * * {Number} inflateAmount hover 時に設定する inflateAmount
 */
export default {
  id: 'barInflateOnHoverPlugin',
  // thisに前回値を持ちたいのでアロー関数ではなく通常関数として設定
  beforeEvent(chart, args, options) {
    const { event } = args
    if (event.type === 'mousemove') {
      const items = chart.getElementsAtEventForMode(
        event,
        'point',
        { intersect: false },
        false
      )
      if (items.length) {
        const element = items[0].element
        if (this.lastElement && element !== this.lastElement) {
          // 対象が変化したので前のelementの状態を戻す
          this.lastElement.inflateAmount = this.lastAmount
          // 復元用にamountの値を保持
          this.lastAmount = element.inflateAmount
        }
        this.lastElement = element
        element.inflateAmount = options.inflateAmount
      } else if (this.lastElement) {
        this.lastElement.inflateAmount = this.lastAmount
        this.lastElement = null
        this.lastAmount = 0
      }
    }
  },
  defaults: {
    inflateAmount: 1,
  },
}
